const getElementChart = (nameElementChart, imageFormat) => {
  const chart = document
    .getElementById(nameElementChart)
    .toDataURL(`image/${imageFormat}`, 1.0);
  return chart;
};
export default getElementChart;
